import { SnapshotIn, types } from "mobx-state-tree";

export const InstallationCode = types.model({
    id: types.string,
    status: types.maybeNull(types.string),
    installation_job_id: types.maybeNull(types.string),
});

export type InstallationCode = SnapshotIn<typeof InstallationCode>